// Diwali 2026 festive mode. Auto-expires after DIWALI_DATE. Set ENABLED=false to switch off early.
export const DIWALI_DATE = "2026-11-08";
const ENABLED = true;
const DELIVERY_CUTOFF_DAYS = 3;

const dayDiff = (iso) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const [y, m, d] = iso.split("-").map(Number);
  return Math.round((new Date(y, m - 1, d) - today) / 86400000);
};

export const getDiwali = () => {
  const toDiwali = dayDiff(DIWALI_DATE);
  const active = ENABLED && toDiwali >= 0;
  const deliveryDaysLeft = toDiwali - DELIVERY_CUTOFF_DAYS;
  return { active, toDiwali, deliveryDaysLeft, showCountdown: active && deliveryDaysLeft >= 1 };
};
